"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var prefix = 'react-spring: ';
var flagInterpolate = false;

function deprecateInterpolate() {
  if (!flagInterpolate) {
    flagInterpolate = true;
    console.warn(prefix + 'interpolate() will be deprecated in v10, use .to()');
  }
}

exports.deprecateInterpolate = deprecateInterpolate;